import { Button, Grid, HStack, Icon, Text, Tooltip } from '@chakra-ui/react';
import { useSidebarContext } from 'context/SidebarContext';
import { useTranslation } from 'react-i18next';
import { LuSlash } from 'react-icons/lu';

import { fontWeights } from '../../global/Fonts';
import { activeSeasonalEffectConfig } from './seasonalEffectConfig';

type SeasonalEffectToggleButtonProps = {
  isCollapsed?: boolean;
};

export const SeasonalEffectToggleButton = ({ isCollapsed = false }: SeasonalEffectToggleButtonProps) => {
  const { t } = useTranslation();
  const { isSeasonalEffectEnabled, setIsSeasonalEffectEnabled } = useSidebarContext();

  if (!activeSeasonalEffectConfig) {
    return null;
  }

  const label = isSeasonalEffectEnabled ? t('sidebar:seasonal_effect.disable') : t('sidebar:seasonal_effect.enable');

  const button = (
    <Button
      variant="unstyled"
      w="full"
      display="block"
      px={3}
      borderRadius="md"
      transition="none"
      fontFamily="body"
      fontWeight={fontWeights.normal}
      size="md"
      data-group
      aria-label={isCollapsed ? label : undefined}
      _hover={{ bg: 'whiteAlpha.400' }}
      onClick={() => setIsSeasonalEffectEnabled((enabled) => !enabled)}
    >
      <HStack spacing="3" w="full" h="full">
        <Grid>
          <Icon as={activeSeasonalEffectConfig.icon} boxSize="6" transition="none" _groupHover={{ color: 'inverted' }} />
          {isSeasonalEffectEnabled && (
            <Icon position="absolute" boxSize="10" top="7px" left="2.5" color="gray.300">
              <LuSlash />
            </Icon>
          )}
        </Grid>
        {!isCollapsed && <Text as="span">{label}</Text>}
      </HStack>
    </Button>
  );

  if (!isCollapsed) {
    return button;
  }

  return (
    <Tooltip label={label} placement="right" hasArrow openDelay={200}>
      {button}
    </Tooltip>
  );
};
